/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-06 17:00:09
 * @LastEditTime: 2022-04-06 18:17:09
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\parameterManage\request.js
 */
import request from '@/utils/request';

// 理赔参数-分页
export function claimsParamList(data) {
  return request.post('/admin/claims-param/list', data);
}

// 理赔参数-详情
export function claimsParamDetail(data) {
  return request.post('/admin/claims-param/detail', data);
}

// 理赔参数-新增
export function claimsParamAdd(data) {
  return request.post('/admin/claims-param/store', data);
}

// 理赔参数-修改
export function claimsParamEdit(data) {
  return request.post('/admin/claims-param/edit', data);
}
// 理赔参数-删除
export function claimsParamDelete(data) {
  return request.post('/admin/claims-param/delete', data);
}
// 理赔参数-资源
export function claimsParamResource(data) {
  return request.post('admin/claims-param/resource', data);
}